const config = {
    baseUrl: '/',
    serverPath: (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1'),
    environment: (process.env.REACT_APP_ENV || ''),
    // serverPath: 'http://localhost:9875/neuApi/authadmin',
    apiKey: 'AIzaSyCrNt433szZCY7s1gTWkrns9L5IXPRT4QE',
    authDomain: 'fbneu-3582c.firebaseapp.com',
    projectId: 'fbneu-3582c',
    storageBucket: 'fbneu-3582c.firebasestorage.app',
    messagingSenderId: '781943828022',
    appId: '1:781943828022:web:f66235515225758882b297',
    measurementId: 'G-LGD6YPMCLC'

};
export default config;